import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ProviderSummary } from 'mbs-ui-shared@models/Provider';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResellerProvidersService {
  private httpClient = inject(HttpClient);

  private readonly baseHref = '/api/providers';

  public getTypes(): Observable<ProviderSummary[]> {
    return this.httpClient.get<ProviderSummary[]>(`${this.baseHref}`, { withCredentials: true });
  }
}
